export const FF_CANCEL_BO =
  process.env.REACT_APP_FF_CANCEL_BOOKING_ORDER === "true"
export const BOOKING_ORDER_QUERY_KEY = "booking-order"
export const BO_CANCEL_MAX_FILE_SIZE_BYTES =
  process.env.REACT_APP_BO_CANCEL_MAX_FILE_SIZE_BYTES ?? 10000
